import { render, staticRenderFns } from "./TextView.vue?vue&type=template&id=a19fa7b2&scoped=true&"
import script from "./TextView.vue?vue&type=script&lang=js&"
export * from "./TextView.vue?vue&type=script&lang=js&"
import style0 from "./TextView.vue?vue&type=style&index=0&id=a19fa7b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a19fa7b2",
  null
  
)

export default component.exports